import { render, staticRenderFns } from "./CriarEsclarecimentoImpugnacao.vue?vue&type=template&id=0b0aca94&"
import script from "./CriarEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
export * from "./CriarEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
import style0 from "./CriarEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=0b0aca94&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports